import {
  dissoc, map, when, curry, pipe, is,
} from 'ramda';

const removeKey = curry((key, obj) => map(when(is(Object), pipe(dissoc(key), removeKey(key))), obj));

export const removeIds = removeKey('id');
